<app-form-step-instructions [form]="form" variant="locked" />

<div class="form-step-fields" [formGroup]="form">
	<tec-form-group
		[label]="('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_TITLE' | translate) + '*'"
		[description]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_DESCRIPTION' | translate"
	>
		@if (showPresetFieldsPreview) {
			<div formArrayName="fields">
				<app-form-step-composite-fields-preview
					[preset]="preset"
					[fieldsArray]="fieldsArray"
					[selectedLocaleId]="selectedStepLocaleId"
				/>
			</div>
		}
	</tec-form-group>
</div>
